<template>
  <div class="pv-page">

    <!-- Hero -->
    <div class="pv-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-book-education-outline</v-icon>
        </v-avatar>
        <div v-if="cargado">
          <div class="pv-hero__title">{{ parsePrograma(programa) }}</div>
          <div class="pv-hero__sub">
            <v-icon x-small color="rgba(255,255,255,0.6)" class="mr-1">mdi-map-marker-outline</v-icon>
            {{ programa.sede.nombre }}
          </div>
        </div>
        <div v-else>
          <div class="pv-hero__title">Detalle del Programa</div>
        </div>
      </div>
      <v-btn small dark text @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <div class="pv-body" v-if="cargado">

      <v-row dense>

        <!-- Columna izquierda: Postgrado -->
        <v-col cols="12" md="6" v-if="is_esam">
          <v-card outlined class="pv-card mb-4" >
            <v-card-title class="pv-section-title py-2 px-4">
              <v-icon small color="indigo darken-2" class="mr-1">mdi-school-outline</v-icon>
              Postgrado
            </v-card-title>
            <v-card-text class="pt-3 pb-2 px-4">
              <div v-if="programa.postgrado.objetivo" class="mb-2">
                <span class="pv-label">Objetivo</span>
                <div class="pv-value">{{ programa.postgrado.objetivo }}</div>
              </div>
              <div v-if="programa.postgrado.dirigido" class="mb-2">
                <span class="pv-label">Dirigido a</span>
                <div class="pv-value">{{ programa.postgrado.dirigido }}</div>
              </div>
              <v-row dense class="mt-1">
                <v-col cols="6">
                  <span class="pv-label">Duración</span>
                  <div class="pv-value">{{ programa.postgrado.duracion }} {{ parseUnidadDur(programa.postgrado.unidad_duracion) }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Creditaje</span>
                  <div class="pv-value">{{ programa.postgrado.creditaje }} Horas</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Carga horaria</span>
                  <div class="pv-value">{{ programa.postgrado.carga_horaria }} Horas</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Área</span>
                  <div class="pv-value">{{ programa.postgrado.area.nombre }}</div>
                </v-col>
                <v-col cols="12">
                  <span class="pv-label">Categoría</span>
                  <div class="pv-value">{{ programa.postgrado.categoria.nombre }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Columna derecha: Programa -->
        <v-col cols="12" md="6">
          <v-card outlined class="pv-card mb-4">
            <v-card-title class="pv-section-title py-2 px-4">
              <v-icon small color="indigo darken-2" class="mr-1">mdi-clipboard-text-outline</v-icon>
              Programa
            </v-card-title>
            <v-card-text class="pt-3 pb-2 px-4">
              <v-row dense>
                <v-col cols="6">
                  <span class="pv-label">Versión</span>
                  <div class="pv-value">{{ programa.version }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Grupo</span>
                  <div class="pv-value">{{ programa.grupo }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Fecha inicio</span>
                  <div class="pv-value">{{ parseFecha(programa.fecha_inicio) }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Finaliza</span>
                  <div class="pv-value">{{ parseFecha(programa.fecha_fin) }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Gestión</span>
                  <div class="pv-value">{{ programa.gestion }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Fase</span>
                  <div>
                    <v-chip x-small label color="indigo lighten-5"
                      class="indigo--text text--darken-2 font-weight-medium mt-1">
                      {{ parseFase(programa.fase) }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Mod. Finalizado</span>
                  <div class="pv-value">{{ programa.mod_finalizado }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Convenio</span>
                  <div class="pv-value">{{ programa.universidad ? programa.universidad.nombre : '-' }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Coordinador</span>
                  <div class="pv-value">{{ coordinador || '-' }}</div>
                </v-col>
                <v-col cols="6">
                  <span class="pv-label">Responsable</span>
                  <div class="pv-value">{{ responsable || '-' }}</div>
                </v-col>

                <v-col cols="6">
                  <span class="pv-label">Área</span>
                  <div class="pv-value">{{ programa.postgrado.area.nombre }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>

      <!-- Enlace pre-inscripción -->
      <v-card outlined class="pv-card mb-4">
        <v-card-text class="py-3 px-4 d-flex align-center flex-wrap" style="gap:12px;">
          <v-btn depressed color="indigo darken-1" dark
            :disabled="programa.fase >= 2" @click="abrirgeneradorEnlace()">
            <v-icon left small>mdi-link-variant</v-icon> Obtener enlace de pre-inscripción
          </v-btn>
          <span v-if="programa.fase >= 2" style="font-size:0.8rem; color:#c62828;">
            El enlace solo está disponible cuando el programa está en fase de inscripciones.
          </span>
        </v-card-text>
      </v-card>

      <!-- Tabla de módulos -->
      <v-card outlined class="pv-table-card">
        <v-card-title class="pv-section-title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-view-list-outline</v-icon>
          Módulos
        </v-card-title>
        <v-data-table
          :headers="headersModulos"
          :items="programa.programa_modulos"
          :items-per-page="-1"
          hide-default-footer
          dense
          class="pv-table"
          no-data-text="Sin módulos."
        >
          <template v-slot:[`item.modulo.nombre`]="{ item }">
            <span :title="'ID: ' + item.id">{{ item.modulo.nombre }}</span>
          </template>
          <template v-slot:[`item.docente`]="{ item }">
            {{ parseDoce(item.docente) }}
          </template>
          <template v-slot:[`item.inicio`]="{ item }">
            {{ parseFecha(item.inicio) }}
          </template>
          <template v-slot:[`item.fin`]="{ item }">
            {{ parseFecha(item.fin) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="indigo darken-1" v-bind="attrs" v-on="on"
                  @click="openOpcionesModulo(item, programa)">
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Información del módulo</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <!-- Loading state -->
    <div v-else class="d-flex justify-center align-center" style="min-height: 300px;">
      <v-progress-circular indeterminate color="indigo" size="48" />
    </div>

    <notifications group="auth" position="bottom right" />
    <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <modald id="modald" v-bind:obj="seleccionadoD" v-on:exito="modalExitoD" />
    <genenlace ref="generarenlace" />
    <psessiones ref="psessiones" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { parseJsonError, error } from '@/components/Utils.js';
import modal from '@/components/AAsignarCourseid.vue';
import modald from '@/components/AAsignarDocente.vue';
import genenlace from '@/components/AGenerarEnlace.vue';
import psessiones from '@/components/APrograma-sessiones.vue';
import xaxios from '@/xaxios';

export default {
  components: { modal, modald, genenlace, psessiones },
  data() {
    return {
      api_rest: process.env.VUE_APP_API_REST,
      msg: '',
      issessiondis: false,
      cargado: false,
      courseid: 0,
      seleccionado:  { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      seleccionadoD: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      programa: {
        sede: {},
        postgrado: { categoria: {}, area: {} },
        universidad: {},
      },
      responsable: null,
      coordinador: null,
      headersModulos: [
        { text: '#',          value: 'numero',       width: 60  },
        { text: 'Módulo',     value: 'modulo.nombre' },
        { text: 'Course ID',  value: 'course_id',    width: 100 },
        { text: 'Docente',    value: 'docente',      width: 180, sortable: false },
        { text: 'Inicio',     value: 'inicio',       width: 100, sortable: false },
        { text: 'Fin',        value: 'fin',          width: 100, sortable: false },
        { text: 'Opciones',   value: 'actions',      width: 80,  sortable: false },
      ],
    };
  },
  computed:{
    is_esam(){
      const u = this.$store.state.CARGO.sede.unidad_negocio;
      if(u == 1 || u == 5){
        return false
      }
      return true
    }
  },
  methods: {
    opensessiones(item) {
      if (!this.issessiondis) {
        this.$notify(error('Denegado', 'Acceso denegado a esta opcion.'));
      } else {
        this.$refs.psessiones.openmodal(item);
      }
    },
    openOpcionesModulo(mod, prog) {
      window.console.log('-----', mod, prog);
      let idmod = mod.modulo.id;
      let nombre = mod.modulo.nombre;
      let numero = mod.numero;
      let programa_modulo_id = mod.id;
      let programa_id = this.programa.id;
      this.$router.push(`moduloopciones?modulo_id=${idmod}&nombre=${nombre}&numero=${numero}&programa_modulo_id=${programa_modulo_id}&programa_id=${programa_id}`);
    },
    verNotas(p) {
      window.sessionStorage.setItem('xmod', JSON.stringify(p));
      this.$router.push({ name: 'xnotas' });
    },
    parseDoce(d) {
      if (!d) return '---';
      if (!d.seg_apellido) d.seg_apellido = '';
      return d.nombres + ' ' + d.pri_apellido + ' ' + d.seg_apellido;
    },
    parseUnidadDur(u) {
      if (u == 0) return 'Meses';
      if (u == 1) return 'Semanas';
      if (u == 2) return 'Días';
      if (u == 3) return 'Horas';
      return '?';
    },
    parsePrograma(p) {
      if (p == null) return '';
      return p.nombre_compuesto;
    },
    parseFecha(fe) {
      if (fe == null) return ' ';
      var vs = fe.split('-');
      return vs[2] + '/' + vs[1] + '/' + vs[0];
    },
    parseFase(fase) {
      if (fase == 1) return 'Inscripciones Abiertas';
      if (fase == 2) return 'En Desarrollo';
      if (fase == 3) return 'En Trámites';
      if (fase == 4) return 'Finalizado/Cerrado';
      return 'Desconocido';
    },
    modalExito() { this.getDatos(); },
    modalExitoD() {},
    abrirgeneradorEnlace() {
      this.$refs.generarenlace.open(this.programa);
    },
    abrirAsignarDocente(mod) {
      var obj = mod.modulo;
      var msg = 'Asignar Docente al modulo';
      var body = 'Para seleccionar un docente ingrese el nombre o documento del docente\n\n';
      this.seleccionadoD = { xid: obj.id, xidpro: this.programa.id, xtitle: msg, xbody: body, xsql: '' };
    },
    asigarCourseId(mod) {
      var obj = mod.modulo;
      var msg = 'Asignar Codigo de curso';
      var body = 'Ingrese el codigo del curso, este codigo pertenece al modulo en la plataforma Moodle\n\n';
      this.seleccionado = { xid: obj.id, xidpro: this.programa.id, xtitle: msg, xbody: body, xsql: '' };
    },
    async getDatos() {
      if (this.programa == null) return;
      const vue = this;
      var sql = gql`query{ getPrograma(id:${this.programa.id}){id,version,nombre_compuesto,grupo,fecha_inicio,fecha_fin,gestion,postgrado{ objetivo,dirigido,duracion,unidad_duracion,creditaje,carga_horaria,programas{id},categoria{id nombre},area{id nombre} },sede{nombre unidad_negocio},fase,mod_finalizado,universidad{nombre},programa_modulos{id,course_id,modulo{	id,nombre},docente{nombres,pri_apellido,seg_apellido},numero,inicio,fin,puntuacion,estado}} }`;
      await this.$apollo
        .query({ query: sql })
        .then((data) => {
          vue.programa = data.data.getPrograma;
          if (vue.programa == null) {
            vue.$notify(error('ERROR', 'getPrograma'));
            return;
          }
          vue.programa.programa_modulos.sort(function(a, b) { return a.numero - b.numero; });
          vue.cargado = true;
          vue.courseid = vue.programa.programa_modulos;
        })
        .catch((err) => {
          vue.cargado = true;
          this.$notify(parseJsonError(err, 'getPrograma'));
        });

      let url = `${this.api_rest}/esam/programa/id/${this.programa.id}`;
      await xaxios.get(url).then(({ data: { datos_coordinador, datos_responsable } }) => {
        if (datos_coordinador) {
          let { coordinador } = datos_coordinador;
          vue.coordinador = datos_coordinador && coordinador
            ? `${coordinador.nombres} ${coordinador.primer_apellido} ${coordinador.segundo_apellido}`
            : null;
        }
        if (datos_responsable) {
          let { responsable } = datos_responsable;
          vue.responsable = datos_responsable && responsable
            ? `${responsable.nombres} ${responsable.primer_apellido} ${responsable.segundo_apellido}`
            : null;
        }
      });
    },
  },
  mounted() {
    this.issessiondis = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 8
      || this.$store.state.CARGO.id == 6 || this.$store.state.CARGO.id == 7;
    var xp = window.sessionStorage.xprograma;
    if (xp) {
      var p = JSON.parse(xp);
      if (p) this.programa = p;
    }
    this.getDatos();
  },
};
</script>

<style scoped>
.pv-page { min-height: 100vh; background: #f5f7fa; }

.pv-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pv-hero__title { font-size: 1.05rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pv-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pv-body { padding: 20px 24px; }

.pv-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.pv-section-title {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  color: #283593;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e8edf7;
}

.pv-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
  display: block;
}
.pv-value {
  font-size: 0.83rem;
  color: #283593;
  font-weight: 500;
  margin-top: 1px;
  margin-bottom: 4px;
}

.pv-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.pv-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.pv-table >>> tbody tr:hover { background: #f0f4ff !important; }
.pv-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
